import { AccountSettings, UserSettings } from './types';

export enum UserSettingsActionTypes {
  FETCH_USER_SETTINGS_REQUEST = '@@users/FETCH_USER_SETTINGS',
  FETCH_USER_SETTINGS_SUCCESS = '@@users/FETCH_USER_SETTINGS_SUCCESS',
  FETCH_USER_SETTINGS_ERROR = '@@users/FETCH_USER_SETTINGS_ERROR',
  FETCH_ACCOUNT_SETTINGS_REQUEST = '@@users/FETCH_ACCOUNT_SETTINGS',
  FETCH_ACCOUNT_SETTINGS_SUCCESS = '@@users/FETCH_ACCOUNT_SETTINGS_SUCCESS',
  FETCH_ACCOUNT_SETTINGS_ERROR = '@@users/FETCH_ACCOUNT_SETTINGS_ERROR',
  POST_ACCOUNT_SETTINGS_REQUEST = '@@users/POST_ACCOUNT_SETTINGS_REQUEST',
  POST_ACCOUNT_SETTINGS_SUCCESS = '@@users/POST_ACCOUNT_SETTINGS_SUCCESS',
  POST_ACCOUNT_SETTINGS_ERROR = '@@users/POST_ACCOUNT_SETTINGS_ERROR',
}

interface IGetUserSettingsSuccess {
  type: typeof UserSettingsActionTypes.FETCH_USER_SETTINGS_SUCCESS;
  userSettings: UserSettings;
  status: number;
}

interface IGetUserSettingsError {
  type: typeof UserSettingsActionTypes.FETCH_USER_SETTINGS_ERROR;
  isFetching?: boolean;
  status: number;
}

interface IGetUserSettings {
  type: typeof UserSettingsActionTypes.FETCH_USER_SETTINGS_REQUEST;
  isFetching?: boolean;
  status: number;
}
interface IGetAccountSettings {
  type: typeof UserSettingsActionTypes.FETCH_ACCOUNT_SETTINGS_REQUEST;
  isFetching?: boolean;
  status: number;
}

interface IGetAccountSettingsSuccess {
  type: typeof UserSettingsActionTypes.FETCH_ACCOUNT_SETTINGS_SUCCESS;
  accountSettings: AccountSettings;
  isFetching?: boolean;
  status: number;
}

interface IGetAccountSettingsError {
  type: typeof UserSettingsActionTypes.FETCH_ACCOUNT_SETTINGS_ERROR;
  isFetching?: boolean;
  status: number;
}

interface IPostUserSettings {
  type: typeof UserSettingsActionTypes.POST_ACCOUNT_SETTINGS_REQUEST;
  isFetching?: boolean;
}
interface IPostUserSettingsSuccess {
  type: typeof UserSettingsActionTypes.POST_ACCOUNT_SETTINGS_SUCCESS;
  isFetching?: boolean;
  status: number;
}
interface IPostUserSettingsError {
  type: typeof UserSettingsActionTypes.POST_ACCOUNT_SETTINGS_ERROR;
  isFetching?: boolean;
  status: number;
}

export type UserSettingsActions =
  | IGetUserSettings
  | IGetUserSettingsSuccess
  | IGetUserSettingsError
  | IGetAccountSettings
  | IGetAccountSettingsSuccess
  | IGetAccountSettingsError
  | IPostUserSettings
  | IPostUserSettingsError
  | IPostUserSettingsSuccess;
